<template>
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit('SAVE')"
        >保存</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="submit('DISPATCH')"
        >调度确认</el-button
      >
    </div>
    <!-- 提货 -->
    <PickUpGoods
      v-if="
        transportType == 'ti_huo:transport_type' ||
        transportPlan == 'ru_cang:transport_plan'
      "
      :dispatchId="dispatchId"
      ref="refPickUpGoods"
      :transportType="transportType"
    ></PickUpGoods>
    <!-- 直送 -->
    <DirectDelivery
      :dispatchId="dispatchId"
      ref="refDirectDelivery"
      v-else-if="transportPlan == 'zhi_song:transport_plan'"
    ></DirectDelivery>
    <!-- 外发 -->
    <Outgoing
      :dispatchId="dispatchId"
      ref="refOutgoing"
      v-else-if="transportPlan == 'wai_fa:transport_plan'"
    ></Outgoing>
  </div>
</template>
<script>
import PickUpGoods from "./ComNewStowageEditRX/PickUpGoods.vue";
import DirectDelivery from "./ComNewStowageEditRX/DirectDelivery.vue";
import Outgoing from "./ComNewStowageEditRX/Outgoing.vue";
export default {
  components: {
    PickUpGoods,
    DirectDelivery,
    Outgoing,
  },
  data() {
    return {
      dispatchId: "",
      transportType: "",
      transportPlan: "", //直送 zhi_song:transport_plan  转仓 ru_cang:transport_plan    外发 wai_fa:transport_plan
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    let { dispatchId, transportPlan, transportType } = this.$route.query;
    this.transportType = transportType;
    this.transportPlan = transportPlan;
    if (dispatchId) {
      this.dispatchId = dispatchId;
    }
  },
  destroyed() {},
  methods: {
    // 提交
    async submit(saveType) {
      if (this.transportType == "ti_huo:transport_type") {
        this.$refs.refPickUpGoods.submit(saveType);
      } else {
        if (this.transportPlan == "wai_fa:transport_plan") {
          this.$refs.refOutgoing.submit(saveType);
        }
        if (this.transportPlan == "zhi_song:transport_plan") {
          this.$refs.refDirectDelivery.submit(saveType);
        }
      }
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}
</style>